import { LucideIcon } from "lucide-react";
import React from "react";
import styled from "styled-components";

interface Props {
  icon?: LucideIcon;
  highlight?: boolean;
  color?: string;
  style?: React.CSSProperties;
  onClick?(): void;
  children?: React.ReactNode;
  title?: string;
  "data-testid"?: string;
}

export function TaskField({
  icon: Icon,
  highlight,
  color,
  style,
  onClick,
  title,
  "data-testid": dataTestId,
  children,
}: Props) {
  return (
    <Root
      onClick={onClick}
      style={style}
      $highlight={highlight}
      title={title}
      data-testid={dataTestId}
    >
      {Icon && <Icon size={16} color={color} />}
      {children && <FieldText>{children}</FieldText>}
    </Root>
  );
}

const Root = styled.div<{ $highlight?: boolean }>`
  opacity: 0.5;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  ${({ $highlight }) => $highlight && `opacity: 1.0;`}
`;

const FieldText = styled.div``;
